import { callAuthorizedGraphQLEndpoint } from "../../module/graphQL";
import CONFIG from "config/config";

export interface UserFontData {
  name: string;
  s3Url: string;
  mimeType: string;
  uploadedAt: string;
  fileSize: string;
}

/**
 * Save user fonts to backend
 */
export const saveUserFonts = (fonts: UserFontData[]) => {
  const mutation = `
    mutation($input: SaveUserFontsInput!) {
      saveUserFonts(input: $input) {
        success
        error
      }
    }`;

  return callAuthorizedGraphQLEndpoint(
    mutation,
    {
      input: {
        fonts: fonts,
      },
    },
    CONFIG.GRAPHQL_API_BASE_URL
  );
};

/**
 * Get user fonts from backend
 */
export const getUserFonts = () => {
  const query = `
    query {
      getUserFonts {
        name
        s3Url
        mimeType
        uploadedAt
        fileSize
      }
    }`;

  return callAuthorizedGraphQLEndpoint(query, {}, CONFIG.GRAPHQL_API_BASE_URL);
};

/** Fonts of a named team (admins may name any team; the backend refuses others). */
export const getTeamFonts = (clientId: string) => {
  const query = `
    query($clientId: ID) {
      getUserFonts(clientId: $clientId) {
        name
      }
    }`;

  return callAuthorizedGraphQLEndpoint(query, { clientId }, CONFIG.GRAPHQL_API_BASE_URL);
};

/** Saves fonts to a named team (used by an admin's SVG import into a client's design). */
export const saveTeamFonts = (fonts: UserFontData[], clientId: string) => {
  const mutation = `
    mutation($input: SaveUserFontsInput!) {
      saveUserFonts(input: $input) {
        success
        error
      }
    }`;

  return callAuthorizedGraphQLEndpoint(mutation, { input: { fonts, clientId } }, CONFIG.GRAPHQL_API_BASE_URL);
};

/**
 * Remove a user font from backend
 */
export const removeUserFont = (fontName: string) => {
  const mutation = `
    mutation($input: RemoveUserFontInput!) {
      removeUserFont(input: $input) {
        success
        error
      }
    }`;

  return callAuthorizedGraphQLEndpoint(
    mutation,
    {
      input: {
        fontName: fontName,
      },
    },
    CONFIG.GRAPHQL_API_BASE_URL
  );
};
